/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigListRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigListRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigListRequest>): ServiceNowCmdbConfigListRequest {
        let obj = Object.assign(new ServiceNowCmdbConfigListRequest(), model);
        ServiceNowCmdbConfigListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigListRequest>): ServiceNowCmdbConfigListRequest {
        if (!model) return null;
        return ServiceNowCmdbConfigListRequest.newInstance(<ServiceNowCmdbConfigListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigListRequest) {
        if (!obj) return;

        models.ServiceNowCmdbConfigListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigListRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the Tenant that user has access to
     */
    tenant_id: string;

    /**
     * Id of the ServiceNow Account in Corestack
     */
    cmdb_account_id: string;

}
